const allowedExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".heic",
  ".heif",
  ".bmp",
  ".pdf",
];

export const isAllowedAttachment = (file) => {
  const type = (file.type || "").toLowerCase();
  if (type.startsWith("image/") || type === "application/pdf") {
    return true;
  }
  const name = (file.name || "").toLowerCase();
  return allowedExtensions.some((ext) => name.endsWith(ext));
};
